import React from 'react';
import { useQuery } from '@apollo/client';
import { StringParam, useQueryParams } from 'use-query-params';

import WorkSummaryTray from '@atom/components/mapPortal/workSummary/WorkSummaryTray';
import { GET_WORK_ORDER } from '@atom/graph/work';
import { WorkOrderDetailType } from '@atom/types/work';

const WorkSummaryWrapper = () => {
  const [params, setParams] = useQueryParams({
    view: StringParam,
    id: StringParam,
  });

  const { data, loading } = useQuery<
    { workOrder: WorkOrderDetailType },
    { id: string }
  >(GET_WORK_ORDER, {
    variables: {
      id: params.id,
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'no-cache',
  });

  const onCancel = () => {
    setParams({
      view: 'list',
      id: '',
    });
  };

  return (
    <WorkSummaryTray
      workOrderDetail={data?.workOrder}
      loading={loading}
      onCancel={onCancel}
    />
  );
};

export default WorkSummaryWrapper;
